<template>
    <div class="factory-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="factoryListComponent"
                :filters="filters"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'factoryList',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/main/components/factory-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getFactories() {
            this.$refs.factoryListComponent && this.$refs.factoryListComponent.getFactories && this.$refs.factoryListComponent.getFactories();
        }
    }
};
</script>

<style scoped lang="scss">
.factory-list {
    margin-top: 16px;
}
</style>
